import { message, Table, TableColumnsType, Tag } from 'antd';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TEXT_BUTTON_HEADER_LIST } from '../../../config/config';
import { PermissionShipping } from '../../../permissions/PermissionShipping';
import customerStore from '../../../stores/customerStore';
import BreadCrumbComponent from '../../atoms/BreadCrumbComponent';
import ActionButton from '../../atoms/ButtonComponent';
import FileUpload from '../../atoms/FileUploadComponent';
import PermissionComponent from '../../atoms/PermissionComponent';
import ContentBox from '../../molecules/ContentBox';
import LoadingWrapper from '../../molecules/LoadingWrapper';
import Permission from '../../molecules/Permission';


const breadCrumb = [
    {
        title: <Link to="/dashboard">Dashboard</Link>,
    },
    {
        title: <p>Upload de Clientes em Massa</p>,
    },
]

interface DataType {
    active: boolean;
    name: string;
    uuid: string;
    key: React.Key;
}

const CreateMassCustomerInclusion: React.FC = observer(() => {
    const [uploadFile, setUploadFile] = useState();
    const navigate = useNavigate();
    const listRouter = () => { navigate(`/fretes`); }
    const { customerMassListError, loading } = customerStore;

    const initialValues = {
    };

    // Faz o filtro da tabela
    const handleSubmit = async () => {
        if (uploadFile) {
            await customerStore.massCustomerUpload(uploadFile);
        } else {
            message.success('Nenhum Arquivo Selecionado');
        }
    };


    const handleFileProcessed = async (file: any) => {
        setUploadFile(file);
    };


    const columns: TableColumnsType<DataType> = [
        {
            title: 'Linha',
            dataIndex: 'line',
            key: 'line',
            sorter: false,
        },
        {
            title: 'Mensagem',
            dataIndex: 'message',
            key: 'message',
            sorter: false,
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'active',
            render: () => {
                return (
                    <Tag color={'red'}><p>Erro</p></Tag>
                );
            },
        },
    ];

    const handleExport = () => {
        const link = document.createElement("a");
        link.href = "assets/documents/ModeloClienteImportacaoMassa.csv";
        link.download = "ModeloClienteImportacaoMassa.csv";
        link.click();
    };

    return (
        <>
            <BreadCrumbComponent breadCrumbList={breadCrumb} textButton={TEXT_BUTTON_HEADER_LIST} onClick={() => listRouter()} />


            <Permission
                permissionKeys={[PermissionShipping.POST, PermissionShipping.GET]}
                fallback={<PermissionComponent />}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                >
                    <Form>
                        <ContentBox className="mb-4 p-6" title="Inclusão de Clientes em Massa" description='Tela para importação de Clientes em Massa'>
                            <div className="flex pt-3 gap-4 items-end">
                                <div className="w-full">
                                    <FileUpload returnOriginalFile={true} validateFilledFields={false} accept=".csv" title="Selecione o arquivo" onFileProcessed={handleFileProcessed} requiredColumns={
                                        [
                                            'CPF/CNPJ (!)',
                                            // 'Ativo (!)',
                                            // 'Primeiro Nome (!)',
                                            // 'Data de Nascimento/Data de Abertura (!)',
                                            // 'Email',
                                            // 'Administrador ResponsÃ¡vel',
                                            // 'CÃ³digo Externo',
                                            // 'Apelido',
                                            // 'GÃªnero',
                                            // 'Ãltimo Nome (!)',
                                            // 'Estado Civil',
                                            // 'Telefone',
                                            // 'Celular',
                                            // 'Receber Newsletter',
                                            // 'SMS',
                                            // 'Fraudador',
                                            // 'Isento',
                                            // 'InscriÃ§Ã£o Estadual',
                                            // 'InscriÃ§Ã£o Municipal',
                                        ]} />
                                </div>
                                <ActionButton icon actionType="export" onClick={() => handleExport()}>Baixar Planilha Modelo</ActionButton>
                            </div>
                        </ContentBox>

                        <LoadingWrapper loading={loading} description="Informação de Importação de Cliente">
                            <ContentBox className="mb-4 p-6" description='Informação de Importação de Cliente'>
                                <Table
                                    className="table-custom"
                                    columns={columns}
                                    dataSource={customerMassListError.map((item: any, index: number) => ({
                                        ...item,
                                        key: item.uuid || index,
                                    }))}
                                    loading={loading}
                                    size="middle"
                                    bordered={false}
                                    pagination={false}
                                    showSorterTooltip={{ target: 'sorter-icon' }}
                                />
                            </ContentBox >
                        </LoadingWrapper>

                        <div className="flex justify-end">
                            <ActionButton htmlType="submit" actionType="primary">Processar</ActionButton>
                        </div>
                    </Form>
                </Formik >
            </Permission >

        </>
    );
});

export default CreateMassCustomerInclusion;